import { registerPlugin } from '@wordpress/plugins';
import { registerBlockType } from '@wordpress/blocks';
import { Icon, box } from '@wordpress/icons';
import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
import {useEffect} from 'react'

const render = () => {}

registerPlugin('wcpd-disclaimer', {
    render,
    scope: 'woocommerce-cart',
});

const metadata = {
    "apiVersion": 2,
    "name": "wcpd/product-disclaimer-for-woocommerce",
    "version": "2.6.3.3",
    "title": "Cart Disclaimer",
    "category": "media",
    "description": "",
    "supports": {
        "html": false,
        "align": false,
        "multiple": false,
        "reusable": false
    },
    "parent": ["woocommerce/filled-cart-block", "woocommerce/checkout-order-summary-block"],
    "attributes": {
        "lock": {
            "type": "object",
            "default": {
                "remove": true,
                "move": true
            }
        }
    },
    "textdomain": "wcpd"
}

const Block = () => {

    useEffect(() => {
        // Add content to the div after it's rendered        
        if ( wcSettings.wcpd_disclaimer_data.html ) {
            document.getElementById("wcpd_root").innerHTML = wcSettings.wcpd_disclaimer_data.html
        }
    }, []);

    return (
        <div id="wcpd_root" style={{width: "100%"}}></div>
    );
}

registerCheckoutBlock({
    metadata,
    component: Block,
});
